"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var validate_js_1 = __importDefault(require("validate.js"));
var Constraint_1 = __importDefault(require("./Constraint"));
var PhoneUtil_1 = require("./util/PhoneUtil");
validate_js_1.default.validators.phoneNumber = function (value, option) {
    if (PhoneUtil_1.PhoneUtil.isValid(value)) {
        return undefined;
    }
    return option; //option is the error message
};
validate_js_1.default.validators.phoneNumberOptional = function (value, option) {
    if (!value || value.length === 0 || PhoneUtil_1.PhoneUtil.isValid(value)) {
        return undefined;
    }
    return option; //option is the error message
};
validate_js_1.default.validators.phoneNumberCustomer = function (value, option) {
    var regex = RegExp('^(\\+?[0-9]+)((\\-[0-9]+)+)$');
    if (!value || value.length === 0 || regex.test(value)) {
        return undefined;
    }
    return option; //option is the error message
};
var ValidatorUtil = /** @class */ (function () {
    function ValidatorUtil() {
    }
    ValidatorUtil.validatePhoneNumber = function (value) {
        return ValidatorUtil.validateValue(value, Constraint_1.default.phoneNumber);
    };
    ValidatorUtil.validateValue = function (value, constraint) {
        var result = validate_js_1.default({ input: value }, { input: constraint });
        if (result) {
            return result.input[0];
        }
        return undefined;
    };
    ValidatorUtil.validateForm = function (fieldMap) {
        var keys = Object.keys(fieldMap);
        var response = {};
        keys.forEach(function (key) {
            response[key] = ValidatorUtil.validateField(fieldMap[key]);
        });
        return response;
    };
    ValidatorUtil.validateFormField = function (fieldMap, field) {
        var keys = Object.keys(fieldMap);
        var response = {};
        keys.forEach(function (key) {
            if (key === field) {
                response[key] = ValidatorUtil.validateField(fieldMap[key]);
            }
            else {
                response[key] = fieldMap[key];
            }
        });
        return response;
    };
    ValidatorUtil.validateField = function (field) {
        var clonedField = Object.assign({}, field);
        if (field.constraint) {
            var errorId = ValidatorUtil.validateValue(field.value, field.constraint);
            if (field.optional && (!field.value || field.value.length === 0)) {
                errorId = undefined;
            }
            if (errorId) {
                clonedField.errorId = errorId;
                clonedField.invalid = true;
            }
            else {
                clonedField.errorId = '';
                clonedField.invalid = false;
            }
        }
        return clonedField;
    };
    ValidatorUtil.countError = function (fieldMap) {
        var errorCount = 0;
        var keys = Object.keys(fieldMap);
        keys.forEach(function (key) {
            if (fieldMap[key].invalid) {
                errorCount = errorCount + 1;
            }
        });
        return errorCount;
    };
    ValidatorUtil.hasError = function (fieldMap) {
        var errorCount = ValidatorUtil.countError(fieldMap);
        return errorCount != 0;
    };
    return ValidatorUtil;
}());
exports.default = ValidatorUtil;
//# sourceMappingURL=ValidatorUtil.js.map